import { useEffect, useState } from 'react';

const initialState = {
  isLoading: false,
  error: null,
  result: null,
};

const useFetch = (fn, params, depencendies = []) => {
  const [response, setResponse] = useState(initialState);

  useEffect(() => {
    const { ready, abort } = fn.apply(
      null,
      params instanceof Object ? [...params] : [params]
    );

    setResponse({ ...initialState, isLoading: true });
    ready()
      .then((res) => {
        if (res.success) setResponse({ ...initialState, result: res.data });
        else setResponse({ ...initialState, error: res.error });
      })
      .catch((err) => console.log(err));

    return () => abort();
  }, depencendies);

  return response;
};

export default useFetch;
